import { createMediaPath } from "../../media/createMediaPath.js";
import { MediaTemplateEnum } from "../../../types/media.js";
const IMAGE_SIZE = {
  preview: [180, 120]
};
const formatVehicleBrandImage = (marketingMedia, options, template = MediaTemplateEnum.Crop) => {
  const { name: title } = marketingMedia;
  const { media } = options;
  if (!marketingMedia || !marketingMedia.file) {
    return {
      title
    };
  }
  const { id } = marketingMedia.file;
  const params = {
    width: IMAGE_SIZE.preview[0],
    height: IMAGE_SIZE.preview[1]
  };
  const original = createMediaPath(id, media, template, params);
  return {
    title,
    original
  };
};
export {
  formatVehicleBrandImage
};
